"use strict";
exports.__esModule = true;
exports.IncomeVerificationRemovePaystubsExperiment = exports.IncomeVerificationRemovePaystubsVariantValues = void 0;
var types_1 = require("../types");
var IncomeVerificationRemovePaystubsVariantValues;
(function (IncomeVerificationRemovePaystubsVariantValues) {
    // naming convention accounts for additional future variants
    IncomeVerificationRemovePaystubsVariantValues["Treatment"] = "treatment";
})(IncomeVerificationRemovePaystubsVariantValues = exports.IncomeVerificationRemovePaystubsVariantValues || (exports.IncomeVerificationRemovePaystubsVariantValues = {}));
exports.IncomeVerificationRemovePaystubsExperiment = {
    variantID: 'income-verification-remove-paystubs-july-25',
    controlValue: types_1.CONTROL,
    variantValues: IncomeVerificationRemovePaystubsVariantValues
};
